/* src/app/admin-setting/admin-setting.component.css */
/*# sourceMappingURL=admin-setting.component.css.map */
